<app-header></app-header>

<ion-content scrollbar>
  <div class="breadcrumb-margin margin-bottom-3">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <ng-container *ngIf="!isError; else HTTPError">
    <ion-grid>
      <ion-row class="margin-minus-20-mobile">
        <ion-col size="12" 
          class="edit-report__header"
          [ngClass]="{'display-none': reportServ.loading}"  
        >
          <h1 class="edit-report__number">{{ reportServ.report.number }}</h1>
          <ng-container *appHasRole="['report.delete']">
            <ion-button
              class="edit-report__delete-button"
              (click)="ReportDelete()"
              fill="outline"
              *ngIf="!p.renderMobile"
            >
              <ion-icon slot="start" name="trash"></ion-icon>
              {{ "DELETE" | translate }}
            </ion-button>
          </ng-container>
        </ion-col>
        <ion-col size-xl="5" size="12">
          <app-report (HTTPerror)="onHTTPError($event)"></app-report>
        </ion-col>
        <ion-col size-xl="7" size="12">
          <app-card 
            title="{{'REPORT_TASK.TASK_LIST' | translate}}"
            [ngClass]="{'display-none': (loadingTask || reportServ.loading)}"  
          >
            <app-pagination-client-side
              [componentRef]="componentRef"
              [columns]="columnsDefinition"
              [options]="options"
              (rowsLoaderReady)="rowsLoaderServiceReady($event)"
              (actionRequest)="showTaskDetails($event)"
              (headerEmitClick)="addTask()"
              (refreshRequest)="loadReportTasks()"
            >
            </app-pagination-client-side>
          </app-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
  <ng-template #HTTPError>
    <app-api-not-found
      name="REPORT_TASK.REPORT"
      link="app/report"
      returnText="REPORT.RETURN_TO_REPORTS"
      [status]="errorStatus"
    >
    </app-api-not-found>
  </ng-template>
</ion-content>
